import { useSelector } from "react-redux";
import type { RootState } from "@/store";
import ClientUsersSection from "@/features/clients/pages/ClientUsersSection";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

export default function ClientEmployeesPage() {
  const { user } = useSelector((state: RootState) => state.auth);
  
  if (!user?.clientId) {
    return (
      <div className="p-8 text-center">
        <p className="text-slate-500">No client context found. Please log in again.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <section className="relative overflow-hidden rounded-2xl border bg-slate-950 p-6 text-white shadow-lg md:p-8">
        <div className="relative flex flex-wrap items-start justify-between gap-5">
          <div className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-200">Management</p>
            <h1 className="text-3xl font-bold tracking-tight md:text-4xl">User Management</h1>
            <p className="max-w-xl text-sm text-slate-200 md:text-base">
              Manage your organization's internal users, including administrators and staff members.
            </p>
          </div>
        </div>
      </section>

      <Card className="border-slate-200 shadow-sm overflow-hidden">
        <CardHeader className="bg-slate-50 border-b">
          <CardTitle className="text-lg font-bold text-slate-800">User Management</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <ClientUsersSection clientId={user.clientId} />
        </CardContent>
      </Card>
    </div>
  );
}
